import { Global } from "../../Global";

Global.setMockData("getWebResources", [
  {
    sellerId: "1",
    name: "张三",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/1.png",
    major: "Java工程师",
  },
  {
    sellerId: "2",
    name: "李四",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/2.png",
    major: "产品经理",
  },
  {
    sellerId: "3",
    name: "王五",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/3.png",
    major: "UI设计师",
  },
  {
    sellerId: "4",
    name: "赵六",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/4.png",
    major: "前端工程师",
  },
  {
    sellerId: "5",
    name: "孙七",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/5.png",
    major: "后端工程师",
  },
  {
    sellerId: "6",
    name: "周八",
    pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/6.png",
    major: "测试工程师",
  },
]);
